import React, { useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";

export const CopyToClip = ({ onCopy, onChange, isCopied, value }) => {
  return (
    <div>
      <input value={value} onChange={onChange} />

      <CopyToClipboard text={value} onCopy={onCopy}>
        <span>Copy to clipboard with span</span>
      </CopyToClipboard>

      <CopyToClipboard text={value} onCopy={onCopy}>
        <button>Copy to clipboard with button</button>
      </CopyToClipboard>

      {isCopied ? <span style={{ color: "red" }}>Copied.</span> : null}
    </div>
  );
};
